<template>
    <div>
        <div class="px-4 py-10 pt-10 pb-10 mx-auto max-w-screen-xl lg:pt-10 lg:pb-20 lg:px-8 xl:px-12" :style="{ backgroundColor: backgroundColor }">
            <h3 class="text-2xl leading-none text-center lg:text-3xl md:text-2xl font-ww-bold xl:px-12" v-html="heading">
            </h3>

            <div class="grid grid-cols-12 gap-y-6 mt-6 md:mt-10 sm:gap-x-8">
                <div class="col-span-12 lg:col-span-6" v-for="(testimonial, index) in testimonials" :key="index">
                    <div class="h-full" :style="{ backgroundColor: testimonialBackgroundColor }">
                        <div class="grid grid-cols-12 gap-y-4 px-4 py-4 h-full sm:px-8 sm:py-6 md:px-6 md:py-10 sm:gap-x-8">
                            <div class="flex flex-col order-2 col-span-12 justify-between items-end sm:col-span-8 sm:order-1">
                                <div class="md:pb-8 pb-2 mb-3 text-sm sm:text-base !leading-5 font-ww-regular sm:mb-0 text-center md:text-right" v-html="testimonial.text">
                                </div>

                                <div class="w-full">
                                    <nuxt-img :src="starsImageSrc" class="mr-auto ml-auto sm:ml-auto sm:mr-0"
                                        width="96" height="15" alt="stars" loading="lazy" />
                            
                                    <div class="mt-3 text-sm sm:text-base font-ww-regular !leading-5 sm:text-right text-center">
                                        <div>{{ testimonial.name }}</div>
                                    </div>
                                    <div class="mt-1 text-xs text-center font-ww-regular sm:text-right">
                                        <div>{{ testimonial.position }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="order-1 col-span-12 sm:col-span-4 sm:order-2">
                                <div>
                                    <nuxt-img :src="testimonial.imageSrc"
                                        class="object-cover mx-auto w-full h-48 lg:h-48 md:h-60 sm:max-w-full max-w-48"
                                        width="193" height="194" :alt="testimonial.imageAlt" sizes="xs:192px sm:198px md:193px lg:192px xl:193" format="webp" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    heading: {
        type: String,
        default: 'Over 444,270 Americans Have Switched to Lifeboost Coffee\'s Organic, Stomach-Friendly, Full Flavor Coffee"'
    },
    backgroundColor: {
        type: String,
        default: 'white'
    },
    testimonialBackgroundColor: {
        type: String,
        default: '#f7f6f9'
    },
    starsImageSrc: {
        type: String,
        default: '/assets/images/starts-testi.svg'
    },
    testimonials: {
        type: Array,
        default: () => [
            {
                text: 'My wife adores Lifeboost! I recommend it because it\'s an unusually low acid cofee that\'s easy on the teeth and stomach.',
                name: 'Dr. Gary Sanchez, D.D.S.',
                position: 'Board Certified Dentist',
                imageSrc: '/assets/images/doctor-1.jpg',
                imageAlt: 'Dr. Gary Sanchez'
            },
            {
                text: '"Lifeboost Coffee is my favorite! It\'s extremely low acid and easy on the stomach. It gets my 5 star recommendation."',
                name: 'Dr Aaron Oxenrider',
                position: 'Board Certified Chiropractic Physician and Regenerative Medicine Expert',
                imageSrc: '/assets/images/doctor-2.jpg',
                imageAlt: 'Dr Aaron Oxenrider'
            },
            {
                text: '"Lifeboost Coffee is one of the healthiest, smoothest coffee\'s I\'ve ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it\'s a treat I look forward to every day."',
                name: 'Joseph R. Feste, M.D., FACOG, AACS, AACG, Natural Bio Health Hormones & Weight Loss.',
                position: 'member of the American Society of Bariatric Physicians. He has extensive experience in the fields of obstetrics and gynecology,',
                imageSrc: '/assets/images/doctor-3.jpg',
                imageAlt: 'Joseph R. Feste'
            },
            {
                text: '"After tasting Lifeboost, I was WOW\'ed by the difference. Most organic coffees don\'t taste that good! They seem bland in comparison. The ultra low acidity is definitely a PLUS as well. Keep up the good work!"',
                name: 'Mike Clark, MBA, JD, PHD, ABHRT, FAARM',
                position: 'Doctorate in Natural Medicine, Health Practitioner Diplomate in the Clinical Science of Anti-Aging, Fellow and Advanced Fellow of Anti-Aging, Regenerative & Functional Medicine.',
                imageSrc: '/assets/images/doctor-4.jpg',
                imageAlt: 'Mike Clark'
            },
            {
                text: '"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I\'ve ever drank. It doesn\'t hurt my stomach at all! Careful though, it goes down really fast! It\'s my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!"',
                name: 'John Rowley',
                position: 'America\'s Lifestyle Strategist, Best Selling Author and Speaker',
                imageSrc: '/assets/images/doctor-5.jpg',
                imageAlt: 'John Rowley'
            },
            {
                text: '"Lifeboost is by far the smoothest, most delicious coffee I\'ve ever tasted. Whether I\'m using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity."',
                name: 'Shaun Hadsall',
                position: 'Owner of GetLeanAfter40',
                imageSrc: '/assets/images/doctor-6.jpg',
                imageAlt: 'Shaun Hadsall'
            }
        ]
    }
});

defineBuilderComponent({
    friendlyName: 'ListImageInfoRight',
    inputs: [
        {
            name: 'heading',
            type: 'richText',
            friendlyName: 'Heading',
            defaultValue: 'Over 444,270 Americans Have Switched to Lifeboost Coffee\'s Organic, Stomach-Friendly, Full Flavor Coffee"'
        },
        {
            name: 'backgroundColor',
            type: 'color',
            friendlyName: 'Background Color',
            defaultValue: 'white'
        },
        {
            name: 'testimonialBackgroundColor',
            type: 'color',
            friendlyName: 'Testimonial Background Color',
            defaultValue: '#f7f6f9'
        },
        {
            name: 'starsImageSrc',
            type: 'file',
            friendlyName: 'Stars Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue: '/assets/images/starts-testi.svg'
        },
        {
            name: 'testimonials',
            type: 'list',
            friendlyName: 'Testimonials',
            defaultValue: [
                {
                    text: 'My wife adores Lifeboost! I recommend it because it\'s an unusually low acid cofee that\'s easy on the teeth and stomach.',
                    name: 'Dr. Gary Sanchez, D.D.S.',
                    position: 'Board Certified Dentist',
                    imageSrc: '/assets/images/doctor-1.jpg',
                    imageAlt: 'Dr. Gary Sanchez'
                },
                {
                    text: '"Lifeboost Coffee is my favorite! It\'s extremely low acid and easy on the stomach. It gets my 5 star recommendation."',
                    name: 'Dr Aaron Oxenrider',
                    position: 'Board Certified Chiropractic Physician and Regenerative Medicine Expert',
                    imageSrc: '/assets/images/doctor-2.jpg',
                    imageAlt: 'Dr Aaron Oxenrider'
                },
                {
                    text: '"Lifeboost Coffee is one of the healthiest, smoothest coffee\'s I\'ve ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it\'s a treat I look forward to every day."',
                    name: 'Joseph R. Feste, M.D., FACOG, AACS, AACG, Natural Bio Health Hormones & Weight Loss.',
                    position: 'member of the American Society of Bariatric Physicians. He has extensive experience in the fields of obstetrics and gynecology,',
                    imageSrc: '/assets/images/doctor-3.jpg',
                    imageAlt: 'Joseph R. Feste'
                },
                {
                    text: '"After tasting Lifeboost, I was WOW\'ed by the difference. Most organic coffees don\'t taste that good! They seem bland in comparison. The ultra low acidity is definitely a PLUS as well. Keep up the good work!"',
                    name: 'Mike Clark, MBA, JD, PHD, ABHRT, FAARM',
                    position: 'Doctorate in Natural Medicine, Health Practitioner Diplomate in the Clinical Science of Anti-Aging, Fellow and Advanced Fellow of Anti-Aging, Regenerative & Functional Medicine.',
                    imageSrc: '/assets/images/doctor-4.jpg',
                    imageAlt: 'Mike Clark'
                },
                {
                    text: '"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I\'ve ever drank. It doesn\'t hurt my stomach at all! Careful though, it goes down really fast! It\'s my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!"',
                    name: 'John Rowley',
                    position: 'America\'s Lifestyle Strategist, Best Selling Author and Speaker',
                    imageSrc: '/assets/images/doctor-5.jpg',
                    imageAlt: 'John Rowley'
                },
                {
                    text: '"Lifeboost is by far the smoothest, most delicious coffee I\'ve ever tasted. Whether I\'m using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity."',
                    name: 'Shaun Hadsall',
                    position: 'Owner of GetLeanAfter40',
                    imageSrc: '/assets/images/doctor-6.jpg',
                    imageAlt: 'Shaun Hadsall'
                }
            ],
            subFields: [
                {
                    name: 'text',
                    type: 'richText',
                    friendlyName: 'Testimonial Text'
                },
                {
                    name: 'name',
                    type: 'text',
                    friendlyName: 'Person Name'
                },
                {
                    name: 'position',
                    type: 'text',
                    friendlyName: 'Person Position'
                },
                {
                    name: 'imageSrc',
                    type: 'file',
                    friendlyName: 'Person Image',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp']
                },
                {
                    name: 'imageAlt',
                    type: 'text',
                    friendlyName: 'Image Alt Text'
                }
            ]
        }
    ]
});
</script>